<template lang="html">

<div >
  <div class="loader" v-if="loader">
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
  </div>
  <survey-mailing :data-survey="data" v-if="data"></survey-mailing>

</div>
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './sass/survey.css';
import axios from 'axios';
import SurveyMailing from './SurveyMailing.vue';


Vue.use(BootstrapVue);
export default {
  components: {
    SurveyMailing,
  },
  data: () => {
    return {
      data: null,
      contact_id: null,
      survey_id: null,
      round_id: null,
      score: null,
      email: null,
      loader: true,
    };
  },
  
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.contact_id = this.$route.params.contact_id;
      this.survey_id = this.$route.params.survey_id;
      this.round_id = this.$route.params.round_id;
      this.score = this.$route.params.score;
      this.email = this.$route.params.email;
      this.loader = true;
      let url = 'v2/survey/contact/' + this.contact_id + '/round/' + this.round_id + '/' + this.email;
      if (this.score) {
        url += '/' + this.score;
      }
      axios.get(url).then(response => {
        this.data = response.data.data;
        this.loader = false;
        /* set value to email click */ 
        
      }).catch(error => {
        this.loader = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/surveys/v2/App.vue